import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "webhooks-filters-divider__line" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NText = _resolveComponent("NText")!
  const _component_NButton = _resolveComponent("NButton")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['webhooks-filters-divider', { 'webhooks-filters-divider_big': _ctx.isBig }])
  }, [
    (_ctx.label.length)
      ? (_openBlock(), _createBlock(_component_NText, {
          key: 0,
          "default-class": _ctx.computedLabelClass
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.label), 1)
          ]),
          _: 1
        }, 8, ["default-class"]))
      : _createCommentVNode("", true),
    _hoisted_1,
    (_ctx.hasReset)
      ? (_openBlock(), _createBlock(_component_NButton, {
          key: 1,
          class: "webhooks-filters-divider__reset",
          icon: "rotate-left",
          type: "secondary",
          onAction: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('reset')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.reset', 'f')), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 2))
}